import { render, staticRenderFns } from "./metopeDetail.vue?vue&type=template&id=2d41f955&scoped=true&"
import script from "./metopeDetail.vue?vue&type=script&lang=js&"
export * from "./metopeDetail.vue?vue&type=script&lang=js&"
import style0 from "./metopeDetail.vue?vue&type=style&index=0&id=2d41f955&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d41f955",
  null
  
)

export default component.exports